const mutations = {
    changeTabType(state, tabType) {
        state.activeTab = tabType
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js